import { getCookie } from "typescript-cookie";
import SecureStorage from "./secureStorage";
import { readUtmDatasCookie } from "./utmDatasCookie";
import { readPartnerLinkFromSearch } from "./attributionCapture";
import { extractUtmParamsFromSearch } from "../components/pages/customRegister/utmCapture";

const readGaClientId = (): string | undefined => {
  try {
    const match = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.(\d+\.\d+)/);
    return match ? match[1] : undefined;
  } catch {
    return undefined;
  }
};

export const captureBusinessCardAttribution = (search: string): void => {
  const params = new URLSearchParams(search || "");
  SecureStorage.setAttributionData({
    gclid: params.get("gclid") || undefined,
    wbraid: params.get("wbraid") || undefined,
    gbraid: params.get("gbraid") || undefined,
    gad_source: params.get("gad_source") || undefined,
    utm: extractUtmParamsFromSearch(search || ""),
  });
};

export const buildBusinessCardAttribution = (
  search?: string
): Record<string, any> | undefined => {
  if (typeof window !== "undefined" && !window.navigator.cookieEnabled) {
    return undefined;
  }

  const searchStr =
    search ?? (typeof window !== "undefined" ? window.location.search : "");
  const params = new URLSearchParams(searchStr || "");

  const user_utm_data: Record<string, any> = {};

  Object.assign(user_utm_data, readUtmDatasCookie(getCookie("utm_datas")));

  const bp_id = readPartnerLinkFromSearch(params)?.bp_id;
  if (bp_id) user_utm_data.bp_id = bp_id;

  const stored = SecureStorage.getAttributionData();

  const gclid = params.get("gclid") || stored?.gclid;
  if (gclid) user_utm_data.gclid = gclid;
  const wbraid = params.get("wbraid") || stored?.wbraid;
  if (wbraid) user_utm_data.wbraid = wbraid;
  const gbraid = params.get("gbraid") || stored?.gbraid;
  if (gbraid) user_utm_data.gbraid = gbraid;
  const gadSource = params.get("gad_source") || stored?.gad_source;
  if (gadSource) user_utm_data.gad_source = gadSource;

  for (const [key, value] of Object.entries(stored?.utm || {})) {
    if (value) user_utm_data[key] = value;
  }
  for (const [key, value] of Object.entries(
    extractUtmParamsFromSearch(searchStr || "")
  )) {
    if (value) user_utm_data[key] = value;
  }

  const gaClientId = readGaClientId();
  if (gaClientId) user_utm_data.ga_client_id = gaClientId;

  return Object.keys(user_utm_data).length > 0 ? user_utm_data : undefined;
};
